import { privateHttp } from "@/shared/http/private-http";
import type { AddCartProductParams, CartDto } from "../types/cart.dto";

/**
 * O carrinho vive no backend (x-session-id + Bearer quando autenticado) e é
 * separado por loja: toda operação envia o `storeId` da loja ativa. Cada
 * mutação devolve o CartDto atualizado.
 */

/** GET /cart — 204 (vazio) vira null. */
export async function getCart(storeId: number): Promise<CartDto | null> {
    const response = await privateHttp.get<CartDto>("/cart", { params: { storeId } });
    return response.status === 204 ? null : response.data;
}

/** POST /cart/add-product/:productId — adiciona (ou soma) o produto na loja. */
export async function addCartProduct(
    productId: number,
    params: AddCartProductParams
): Promise<CartDto> {
    const { data } = await privateHttp.post<CartDto>(`/cart/add-product/${productId}`, undefined, {
        params,
    });
    return data;
}

/** PUT /cart/item/:productId — define a quantidade do item. */
export async function updateCartItem(
    productId: number,
    quantity: number,
    storeId: number
): Promise<CartDto> {
    const { data } = await privateHttp.put<CartDto>(
        `/cart/item/${productId}`,
        { quantity },
        { params: { storeId } }
    );
    return data;
}

/** PUT /cart/item/:productId/comment — texto vazio remove a observação. */
export async function updateCartItemComment(
    productId: number,
    comment: string,
    storeId: number
): Promise<CartDto> {
    const { data } = await privateHttp.put<CartDto>(
        `/cart/item/${productId}/comment`,
        { comment },
        { params: { storeId } }
    );
    return data;
}

/** DELETE /cart/item/:productId */
export async function removeCartItem(productId: number, storeId: number): Promise<CartDto> {
    const { data } = await privateHttp.delete<CartDto>(`/cart/item/${productId}`, {
        params: { storeId },
    });
    return data;
}

/** DELETE /cart — esvazia o carrinho da loja. */
export async function clearCart(storeId: number): Promise<void> {
    await privateHttp.delete("/cart", { params: { storeId } });
}
